<div class="main d-none">
    <div class="container">
        <h2 class="heading">Lorem ipsum dolor sit amet consectetur</h2>
        <div class="row">
            <div class="col-xl-4 col-lg-4">
                <div class="card">
                    <div class="image">
                        <img src="/assets/banner/save-tax.png" alt="" class="img-fluid">
                    </div>
                    <div class="content">
                        <h4 class="title">Lorem, ipsum</h4>
                        <p class="text">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nulla, dicta?</p>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="card">
                    <div class="image">
                        <img src="/assets/banner/imporve-speed.png" alt="" class="img-fluid">
                    </div>
                    <div class="content">
                        <h4 class="title">Lorem, ipsum</h4>
                        <p class="text">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nulla, dicta?</p>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="card">
                    <div class="image">
                        <img src="/assets/banner/error-free.png" alt="" class="img-fluid">
                    </div>
                    <div class="content">
                        <h4 class="title">Lorem, ipsum</h4>
                        <p class="text">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nulla, dicta?</p>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="card">
                    <div class="image">
                        <img src="/assets/banner/traces-integration.png" alt="" class="img-fluid">
                    </div>
                    <div class="content">
                        <h4 class="title">Lorem, ipsum</h4>
                        <p class="text">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nulla, dicta?</p>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="card">
                    <div class="image">
                        <img src="/assets/banner/dashboard.png" alt="" class="img-fluid">
                    </div>
                    <div class="content">
                        <h4 class="title">Lorem, ipsum</h4>
                        <p class="text">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nulla, dicta?</p>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="card">
                    <div class="image">
                        <img src="/assets/banner/warning.png" alt="" class="img-fluid">
                    </div>
                    <div class="content">
                        <h4 class="title">Lorem, ipsum</h4>
                        <p class="text">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nulla, dicta?</p>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="card">
                    <div class="image">
                        <img src="/assets/banner/rupee.png" alt="" class="img-fluid">
                    </div>
                    <div class="content">
                        <h4 class="title">Lorem, ipsum</h4>
                        <p class="text">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nulla, dicta?</p>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="card">
                    <div class="image">
                        <img src="/assets/banner/FVU-handling.png" alt="" class="img-fluid">
                    </div>
                    <div class="content">
                        <h4 class="title">Lorem, ipsum</h4>
                        <p class="text">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nulla, dicta?</p>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="card">
                    <div class="image">
                        <img src="/assets/banner/single-click.png" alt="" class="img-fluid">
                    </div>
                    <div class="content">
                        <h4 class="title">Lorem, ipsum</h4>
                        <p class="text">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nulla, dicta?</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>